<template>
    <li class="flex items-center cursor-pointer" @click="toggleChecked">
      <jet-checkbox v-model="isChecked" class="mr-2"/>
      <span class="mt-1">{{ label }}</span>
    </li>
  </template>
  
  <script>
  export default {
    name: 'CheckboxItem',
    props: {
      modelValue: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: true
      }
    },
    computed: {
        value() {
            return this.modelValue;
        },
        isChecked: {
            get() {
            return this.value;
            },
            set(newValue) {
            this.$emit('update:modelValue', newValue);
            }
        }
    },
    methods: {
      toggleChecked() {
        this.isChecked = !this.isChecked;
      }
    }
  }
  </script>